module.exports = __webpack_public_path__ + "06_long_black.2f0e724e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/06_long_black.png
// module id = Hjcj
// module chunks = 0